<script>
	const { disabled, children, ...rest } = $props()
</script>

<label data-disabled={disabled} {...rest}>
	{@render children()}
</label>

<style>
	label {
		font-size: 14px;
		text-transform: uppercase;
		color: var(--contrast-gray);
		line-height: 1.2;
		display: inline-block;
		font-weight: 500;
	}

	[data-disabled=true] {
		color: var(--disabled-gray);
	}
</style>
